export default "__VITE_ASSET__Db7QsHu___"